import type { SettlementType } from '@core/db/models'

/* Доменные константы и хелперы админки. Стили живут в @ui/classes и @ui/admin. */

/** Базовый URL облачного API. */
export const CLOUD_API = import.meta.env.VITE_API_URL ?? 'https://api.pospoint.ru/api/v1'

/** Единый текст для экранов, которым нужен вход в облако (ARCH-TASK-60.5). */
export const CLOUD_NOT_CONNECTED =
  'Облако не подключено — войдите в «Интеграциях», чтобы работать с облачными данными'

/** Время жизни вскрытой упаковки до «просрочена» (72 ч). */
export const CONTAINER_SHELF_LIFE_MS = 72 * 60 * 60 * 1000

/** Бейдж типа кассы по device_id (ре-экспорт для совместимости секций). */
export { deviceLabel as deviceBadge } from '@core/utils/deviceLabel'

/** Подписи признаков расчёта (тег 1054 ФФД). */
export const SETTLEMENT_LABELS: Record<SettlementType, string> = {
  income: 'Приход',
  income_return: 'Возврат прихода',
  outcome: 'Расход',
  outcome_return: 'Возврат расхода'
}

/** Подписи способов оплаты (receipts.payment_method). */
export const PAYMENT_LABELS: Record<string, string> = {
  cash: 'Наличные',
  card: 'Карта',
  sbp: 'СБП'
}

/** Человеческая подпись способа оплаты; null/'' → «—» (старые чеки). */
export function paymentLabel(method?: string | null): string {
  if (!method) return '—'
  return PAYMENT_LABELS[method] ?? method
}
